import RightPanel from "../../ui/RightPanel";
import WhatsappButton from "../../ui/WhatsappButton";
import { ChevronLeft } from "lucide-react";
import "../../../styles/modules/auth/_auth.scss";

export default function AuthLayout({
  panelTitle,
  panelSubtitle = "NPS · CSAT · CES · Jornada CX",
  panelDescription,
  hasWhatsappButton = true,
  backButton,
  children,
}) {
  return (
    <div className="auth">
      <div className="auth__content">
        <div className="auth__brand">
          <div className="auth__brand-logo">121</div>
          <span className="auth__brand-name">Insights CX</span>
        </div>
        {backButton && (
          <button onClick={backButton.onClick} className="auth__back-link">
            <ChevronLeft size={14} strokeWidth={2.5} />
            {backButton.text}
          </button>
        )}
        {children}
        <footer className="auth__footer">
          © 2026 121Labs · 121 Insights CX
        </footer>
      </div>
      <RightPanel
        title={panelTitle}
        subtitle={panelSubtitle}
        description={panelDescription}
      />
      {hasWhatsappButton && <WhatsappButton />}
    </div>
  );
}
